import GetHeader from "@/components/api/fanClub/leaders/leadersList";
import GetList from "@/components/api/fanClub/leaders/leadersList";

export default {
  namespaced: true,
  state: {
    memberList: [],
    hasNext: false,
    nextPage: "",
    headerImg: "",
    scrollPositionY: 0,
    scrollPositionX: 0
  },
  getters: {
    memberList: state => state.memberList,
    hasNext: state => state.hasNext,
    nextPage: state => state.nextPage,
    headerImg: state => state.headerImg,
    scrollPositionY: state => state.scrollPositionY,
    scrollPositionX: state => state.scrollPositionX
  },
  mutations: {
    setMemberList(state, lists) {
      state.memberList.push(...lists);
    },
    resetMemberList(state) {
      state.memberList = [];
      state.hasNext = false;
      state.nextPage = "";
    },
    setHasNext(state, payload) {
      state.hasNext = payload;
    },
    setNextPage(state, payload) {
      state.nextPage = payload;
    },
    setHeaderImg(state, payload) {
      state.headerImg = payload;
    },
    resetHeaderImg(state) {
      state.headerImg = "";
    },
    setScrollPosition(state, positionY, positionX) {
      state.scrollPositionY = positionY;
      state.scrollPositionX = positionX;
    },
    resetScrollPosition(state) {
      state.scrollPositionY = 0;
      state.scrollPositionX = 0;
    }
  },
  actions: {
    // memberリストの取得用action
    async getMemberList({ commit }, { categoryName, page, searchQuery }) {
      try {
        let memberInfo = await GetList.getThumbnailList(
          categoryName,
          page,
          searchQuery
        );
        commit("setMemberList", memberInfo.thumbnailList);
        commit("setHasNext", memberInfo.hasNext);
        commit("setNextPage", memberInfo.nextPage);
      } catch (error) {
        console.error("getMemberListのerror:", error);
      }
    },

    // memberリストのリセット用action
    resetMemberList({ commit }) {
      commit("resetMemberList");
    },

    // header画像の取得用action
    async getHeaderImg({ commit }, categoryName) {
      try {
        let headerImg = await GetHeader.getCategoryHeader(categoryName);
        console.log("headerImg:", headerImg);
        commit("setHeaderImg", headerImg.imageUrl);
      } catch (error) {
        console.error("getHeaderImgのerror:", error);
      }
    },

    // header画像のリセット用action
    resetHeaderImg({ commit }) {
      commit("resetHeaderImg");
    },

    // スクロール位置のセット用action
    setScrollPosition({ commit }) {
      const positionY = window.scrollY;
      const positionX = window.scrollX;
      console.log("positionY:", positionY);
      console.log("positionX:", positionX);
      commit("setScrollPosition", positionY, positionX);
    },

    // スクロール位置のリセット用action
    resetScrollPosition({ commit }) {
      commit("resetScrollPosition");
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/leaders.js